let getters = {
  currentStep (state) {
    return state.currentStep;
  },
  numberOfSteps (state) {
    return state.numberOfSteps;
  },
  signupStatus (state) {
    return state.signupStatus;
  },
  userEmail (state) {
    return state.userEmail;
  },
  waitTime (state) {
    return state.waitTime ? state.waitTime : localStorage.getItem('waitTime');
  },
  waitMessage (state) {
    return state.waitMessage;
  },
  presetEmail (state) {
    return state.presetEmail
  },
  dmiEligible (state) {
    return state.dmiEligible
  },
  signupMobile (state) {
    return state.signupMobile
  },
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/signup/getters.js